import { CreateNoteData, UpdateNoteData, NotesResponse, NoteResponse, DeleteNoteResponse, CompaniesWithNotesResponse } from '../types/note';
import api from '../utils/api';

// Get companies with notes (for Notes page)
export const getCompaniesWithNotes = async (params: {
  page?: number;
  limit?: number;
  search?: string;
  adherentFilter?: 'adherent' | 'non-adherent';
} = {}): Promise<CompaniesWithNotesResponse> => {
  const queryParams: Record<string, string> = {};
  
  if (params.page) queryParams.page = params.page.toString();
  if (params.limit) queryParams.limit = params.limit.toString();
  if (params.search) queryParams.search = params.search;
  if (params.adherentFilter) queryParams.adherentFilter = params.adherentFilter;

  const response = await api.get('/notes/companies', {
    params: queryParams
  });

  return response.data;
};

// Get notes by SIREN list
export const getNotesBySiren = async (sirens: string[]): Promise<NotesResponse> => {
  const response = await api.post('/notes/by-siren', { sirens });
  return response.data;
};

// Create a new note
export const createNote = async (noteData: CreateNoteData): Promise<NoteResponse> => {
  const response = await api.post('/notes', noteData);
  return response.data;
};

// Update a note
export const updateNote = async (noteId: number, noteData: UpdateNoteData): Promise<NoteResponse> => {
  const response = await api.put(`/notes/${noteId}`, noteData);
  return response.data;
};

// Delete a note
export const deleteNote = async (noteId: number): Promise<DeleteNoteResponse> => {
  const response = await api.delete(`/notes/${noteId}`);
  return response.data;
}; 